import { NavigateFunction, useNavigate } from 'react-router-dom'

export const path = {
  home: '/',
  dashboard: '/',
  collection: '/collection',
  userAccount: '/user',
  event: '/event',
}

export const adminPath = {
  /** /admin */
  index: '/admin',
  /** /users */
  users: '/users',
}

export function useAppNavigate() {
  const navigate = useNavigate()

  return new AppNavigate(navigate)
}

class AppNavigate {
  private navigate: NavigateFunction

  constructor(navigate: NavigateFunction) {
    this.navigate = navigate
  }

  /**
   * navigate("collection/id", { replace: false })
   */
  toSite(id: string) {
    this.navigate(`${path.collection}/${id}`, { replace: false })
  }

  /**
   * navigate("collection/siteid/eventid", { replace: false })
   */
  toEvent(siteId: string, eventId: string) {
    this.navigate(`${path.collection}/${siteId}/${eventId}`)
  }

  toDataCollection() {
    this.navigate(`${path.collection}`)
  }

  public admin = {
    toDashboard: () => this.navigate(`${adminPath.index}`),
    toUsers: () => this.navigate(`${adminPath.users}`),
  }
}

// export const appNavigate = useAppNavigate()
